import { render, staticRenderFns } from "./employee-config.vue?vue&type=template&id=608a64d0&scoped=true&"
import script from "./employee-config.vue?vue&type=script&lang=js&"
export * from "./employee-config.vue?vue&type=script&lang=js&"
import style0 from "./employee-config.vue?vue&type=style&index=0&id=608a64d0&prod&scoped=true&lang=css&"
import style1 from "./employee-config.vue?vue&type=style&index=1&id=608a64d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a64d0",
  null
  
)

export default component.exports